import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { getRoles } from "../api/roleApi";

import RoleTable from "../components/RoleTable";

import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Skeleton,
  Button,
} from "../components/ui";

const RoleList = () => {
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadRoles = async () => {
    try {
      setLoading(true);
      const data = await getRoles();
      setRoles(data);
    } catch (error) {
      console.error("Error fetching roles list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadRoles();
  }, []);

  return (
    <div className="p-3 sm:p-6 lg:p-8 max-w-7xl mx-auto space-y-5 antialiased">
      {/* Top Header Bar – no decorative icon */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-neutral-200 dark:border-neutral-800 pb-4">
        <div>
          <h1 className="text-xl sm:text-xl sm:text-2xl font-bold tracking-tight text-neutral-900 dark:text-neutral-100">
            Roles & Permissions
          </h1>
          <p className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5">
            Manage system roles, module access, and user privileges.
          </p>
        </div>

        <Link to="/roles/create">
          <Button leftIcon={<Plus className="w-4 h-4" />} className="w-fit">
            Create Role
          </Button>
        </Link>
      </div>

      {/* Main Table View */}
      {loading ? (
        <Card className="border border-neutral-200 dark:border-neutral-800 shadow-none bg-white dark:bg-neutral-900 p-4">
          <CardHeader className="p-0 pb-4">
            <Skeleton height={24} width={150} />
          </CardHeader>
          <CardContent className="p-0 space-y-3">
            <Skeleton height={40} width="100%" />
            <Skeleton height={40} width="100%" />
            <Skeleton height={40} width="100%" />
          </CardContent>
        </Card>
      ) : (
        <Card className="border border-neutral-200 dark:border-neutral-800 shadow-none bg-white dark:bg-neutral-900 overflow-hidden">
          <CardHeader className="border-b border-neutral-200 dark:border-neutral-800 bg-neutral-50/50 dark:bg-neutral-900/50 px-4 sm:px-6 py-3">
            <CardTitle className="text-xs font-semibold text-neutral-700 dark:text-neutral-200 uppercase tracking-wider">
              System Roles Catalog ({roles.length})
            </CardTitle>
          </CardHeader>

          <CardContent className="p-0">
            <RoleTable roles={roles} refreshRoles={loadRoles} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

export default RoleList;
